<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="order?.branch?.company?.watermark && invoiceHeader" :src="getFileServerUrl + order?.branch?.company?.watermark" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="order?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${order?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="order?.supplier">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h1 style="display: flex ; justify-content: center; width: 100%;">{{ order?.supplier?.name }}</h1>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">PROFORMA INVOICE</h2>
                      </div>
                    </td>
                  </tr>

                  <!-- Master Box Section -->
                  <tr class="master-box-parent">
                    <td class="details-table" colspan="100%">
                      <div class="master-box mt-4" style="font-size: 9px;">
                        <v-row>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 50%;"><strong>PI NO.</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 50%;">{{ order?.pi_no || '-' }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>DATE</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ formatDateView(order?.pi_date) || '-' }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>

                        <v-row style="margin-top: -10px;">
                          <v-col cols="6">
                            <div style="height: auto; font-weight: bold; border: 1px solid #000; padding: 2px; min-height: 60px; font-size: 8px;">
                              <strong>EXPORTER/SELLER:</strong><br/>
                              <span>Shenzhen Caiju Tianxia Printing and Tranding Co. Ltd.</span><br/>
                              <span>Office Address: 502 Yayi Building, No. 68 Dongchang Road, Dongxiao community, Dongxiao Street, Luohu District, Shenzhen.</span>
                              <span>TEL: +8615014141131</span>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: auto; font-weight: bold; border: 1px solid #000; padding: 2px; min-height: 60px; font-size: 8px;">
                              <p>EXPORTER'S LC ADVISING BANK NAME, BRANCH & ADDRESS:</p>
                              <p>{{ order?.bank?.name }}</p>
                              <p>ADD: {{ order?.bank?.address }}</p>
                              <p>ACCOUNT NO: {{ order?.bank?.account_no }}</p>
                              <p>SWIFT CODE: {{ order?.bank?.swift_code }}</p>
                            </div>
                          </v-col>
                        </v-row>

                        <v-row style="margin-top: -5px;">
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 50%;"><strong>Vehicle/ Flight No.</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 50%;">By Sea</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 50%;"><strong>Port Of Loading</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 50%;">{{ order?.loading_port?.name }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 40%;"><strong>Port of Discharge</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 60%;">{{ order?.discharge_port?.name }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 40%;"><strong>Final Destination</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 60%;">{{ order?.discharge_port?.name }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>
                        
                        <v-row style="margin-top: -5px;">
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 50%;"><strong>Country of origin good:</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 50%;">China</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 50%;"><strong>Country of Final Destination</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 50%;">Bangladesh</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>

                          <v-col cols="6">
                            <table style="width: 100%; height: 100%;  font-size: 9px;">
                              <tbody style="height: 100%; ">
                                <tr style="height: 100%;">
                                  <td style="border: 1px solid #000; height: 100%; display: flex; justify-content: center; align-items: center;">
                                    {{ order?.payment_term?.name }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <!-- Breakdown Table -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table mt-5" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px; width: 5%;">SL. NO.</th>
                            <th style="border: 1px solid #000; padding: 2px;">DESCRIPTION OF GOODS</th>
                            <th style="border: 1px solid #000; padding: 2px; width: 10%;">H.S. CODE</th>
                            <th style="border: 1px solid #000; padding: 2px; width: 12%;">IN QUANTITY</th>
                            <th style="border: 1px solid #000; padding: 2px; width: 10%;">RATE ({{ order?.currency?.code }} {{ order?.currency?.symbol }})</th>
                            <th style="border: 1px solid #000; padding: 2px; width: 12%;">AMOUNT ({{ order?.currency?.code }} {{ order?.currency?.symbol }})</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in order?.details" :key="row.id">
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ index + 1 }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.product?.name }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row?.hs_code }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row?.quantity }} KGS</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: right;">{{ row?.rate }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: right;">{{ row?.amount }}</td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; text-align: right;" colspan="3"><strong>TOTAL COST VALUE</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: right;"><strong>{{ order?.total_amount }}</strong></td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Terms & Conditions -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                        <tbody>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; text-align: left; font-size: 9px;">
                              <strong>In Words:</strong> {{ convertNumberToWords(order?.total_amount) }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; text-align: left; font-size: 8px; min-height: 80px; vertical-align: top; white-space: pre-wrap; word-wrap: break-word;">
                              {{ order?.terms_and_condition }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Terms & Conditions -->
                  <!-- <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <div class="master-box mt-4" style="font-size: 9px;">
                        <v-row>
                          <v-col cols="6">
                            <div style="border: 1px solid #000; padding: 8px; min-height: 120px;">
                              <strong>TERM & CONDITION OF SHIPMENT:</strong><br/>
                              <div style="margin-top: 8px;">
                                {{ order?.branch?.terms_and_condition || '-' }}
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="border: 1px solid #000; padding: 2px; min-height: 120px; text-align: center;">
                              <div style="margin-top: 40px; font-size: 9px; border-bottom: 1px solid #000; min-height: 30px;"></div>
                              <strong>SIGNATURE OF THE SUPPLIER</strong><br/>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr> -->

                  <!-- Signatures -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <div style="margin-top: 10px;">
                        <v-row style="display: flex; justify-content: flex-end;">
                          <v-col cols="6" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">Authorized Signature</div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <!-- <img v-if="order?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${order?.branch?.company?.footer_image}`" alt="Footer Image" style="width: 100%; display: block;"> -->
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="end" class="d-print-none mt-4 ">
      <v-col cols="12"  justify="center" style="display:flex; justify-content: center;">
          <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
            Print without pad
          </v-btn>
          <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
            Print with pad
          </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import convertNumberToWords from "@/plugins/numberToWord";

const store = useStore();
const route = useRoute();

const invoiceHeader = ref(true);
const pagePadding = ref(0);

const order = ref(null);

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

const totalQuantity = computed(() =>
  order.value.breakdowns.reduce((sum, r) => sum + Number(r.quantity || 0), 0)
);

async function fetchDetails(id) {
  try {
    const res = await store.dispatch("getLcImportPiById", id);
    if (res) {
      order.value = res;

    }
  } catch (err) {
    console.error("Error fetching order details:", err);
  }
}

const print = (isPad) => {

  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {

    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
  
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Profoma Invoice</title>
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
  
        @page {
          size: A4;
          margin: ${pagePadding.value}px 0;
        }
  
        html, body {
          margin: 0 ;
          padding: 0; 
          width: 100%;
          height: auto;
        }
  
        body { 
          font-family: sans-serif; 
          background:#fff; 
          color:#000; 
          -webkit-print-color-adjust: exact; 
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
  
        .report-paper { 
          width: 100%; 
          padding: 0 !important;
          background: #fff;
          margin: 0;
        }
  
        .invoice-container {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        .invoice-content {
          width: 100%;
          margin: 0;
          padding: 0;
          overflow: visible;
        }
  
        header img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
  
        table {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 10;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        footer img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
  
        .page-header {
          margin-bottom: 20px;
          padding: 20px 0;
        }
  
        .header-section { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          border-bottom: 2px solid #eee; 
          padding-bottom: 10px; 
          margin-bottom: 16px; 
        }
  
        .company-name { 
          font-size: 9px; 
          font-weight: bold; 
          text-transform: uppercase; 
          margin: 0 0 4px 0; 
        }
  
        .company-text { 
          font-size: 9px; 
          margin: 2px 0; 
          display: flex; 
          align-items: center; 
        }
  
        .logo-container img { 
          max-height: 70px; 
          max-width: 150px; 
        }
  
        .report-title { 
          font-size: 16px; 
          text-align: center; 
          margin: 8px 0; 
        }
  
        .watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 0;
        }
  
        table { 
          width: 100% !important; 
          border-collapse: collapse; 
          font-size: 9px; 
          margin: 8px 0;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .details-table {
          padding: 0px 28px;
        }
  
        th, td { 
          border: none; 
          padding: 0; 
          vertical-align: middle; 
        }
  
        th { 
          text-align: center; 
          font-weight: bold;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        .master-box-parent {
          border: none !important;
          page-break-inside: avoid;
        }
  
        .master-box {
          margin: 16px 0;
          page-break-inside: avoid;
        }
  
        .invoice-content {
          page-break-inside: avoid;
        }
  
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-left { text-align: left; }
        
        table {
          page-break-inside: avoid;
          orphans: 3;
          widows: 3;
        }
        
        tr {
          page-break-inside: avoid;
        }
        .mt-4 { 
          margin-top: 0px !important;
          margin-left: -10px !important;
          margin-right: -10px !important;
        }
        .mt-5 { 
          margin-top: 5px !important;
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
        .mt-8 { margin-top: 0px !important; }
        .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }
  
        img { 
          max-width: 100% !important; 
          height: auto !important; 
        }
  
        .d-flex { display: flex; }
        .justify-space-between { justify-content: space-between; }
        .align-start { align-items: flex-start; }
        .v-row { 
          display: flex !important; 
          flex-wrap: wrap !important; 
          margin: 0;
          width: 100%;
        }
  
        .v-col-6 { 
          flex: 0 0 50% !important; 
          max-width: 50% !important; 
          padding: 0 12px 12px 12px;
          box-sizing: border-box;
          margin: 0;
        }
  
        .pa-6 { padding: 0 !important; }
  
        .order-table thead {
          display: table-header-group;
          page-break-inside: avoid;
        }
  
        .order-table tbody {
          page-break-inside: avoid;
        }
  
        /* Prevent sections from breaking across pages */
        div[style*="margin-top"], div[style*="padding"] {
          page-break-inside: avoid;
        }
  
        .order-table tbody tr {
          page-break-inside: avoid;
        }
  
        .signature-box {
          font-size: 9px;
          border: 1px solid black;
          border-radius: 5px;
          padding: 10px;
        }
  
        .signature-line {
          border-bottom: 1px solid #000;
          margin: 50px 0;
          height: 30px;
        }
  
        .signature-label {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 9px;
        }
  
        .invoice-container {
          display: flex;
          flex-direction: column;
        }
  
        .invoice-content {
          flex: 1;
          overflow: visible;
          margin-top: -10px;
        }
          
        .company-info {
          flex: 1;
        }
  
        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left; 0;
          bottom: 15px;
          width: 100%;    
        }
  
        @media print { 
          body {
            margin: 0;
            padding: 0;
          }
  
          .report-paper {
            margin: 0;
            padding: 0;
          }
  
          main {
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
          }
  
          .watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 0;
          }
            
          .order-table {
            page-break-inside: auto;
          }
  
          .order-table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
  
          .order-table thead {
            display: table-header-group;
          }
        }
      </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);
  
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500)

};

onMounted(() => {
  const id = route.params.id;
  console.log(id)
  if (id) fetchDetails(id);
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 9px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 9px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 9px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 9px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 9px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

.company-info {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>
